export const prependSlash = <T extends string | null | undefined>(
  url: T,
): T extends string ? string : null => (!url || url.startsWith('/') ? url : `/${url}`) as any;
